<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Manage custom task actions</h1>

      <p-orderList
        [value]="actions"
        [listStyle]="{ height: '250px' }"
        [responsive]="true"
        header="Custom Task Actions"
        (onReorder)="reOrdered(actions)"
        (onSelectionChange)="selectionChanged($event)"
      >
        <ng-template let-action pTemplate="item">
          <div class="ui-helper-clearfix">
            <h2 style="display: inline-block; margin: 2px 0 2px 2px">{{ action.name }}</h2>
            <p-checkbox
              name="completed"
              binary="true"
              [(ngModel)]="action.completed"
              label=""
              class="checkPos"
            ></p-checkbox>
          </div>
        </ng-template>
      </p-orderList>
      <br />
      <div class="ui-helper-clearfix" style="width: 100%">
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>

      <p-dialog
        header="Add a custom task action"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
      >
        <form
          [formGroup]="newCustomTaskActionForm"
          (ngSubmit)="save(newCustomTaskActionForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="customtaskaction">
            <div cclass="ui-g-12">
              <div class="ui-g-4"><label for="name">Name</label></div>
              <div class="ui-g-8">
                <input pInputText id="name" formControlName="name" maxlength="255" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="completed">Completed</label></div>
              <div class="ui-g-8">
                <p-checkbox name="completed" binary="true" formControlName="completed"></p-checkbox>
              </div>
            </div>
          </div>
          <p-footer>
            <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
              <button
                type="button"
                pButton
                icon="fa ui-icon-close"
                (click)="delete()"
                label="Cancel"
              ></button>
              <button
                type="submit"
                pButton
                icon="fa ui-icon-check"
                label="Save"
                [disabled]="newCustomTaskActionForm.invalid"
              ></button>
            </div>
          </p-footer>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
